const CLIENT_ID_KEY = "tx_client_id";
const LOGIN_FAIL_KEY = "tx_login_fail_count";

export const IMAGE_CAPTCHA_FAIL_THRESHOLD = 3;

export interface CaptchaPolicyData {
  required?: boolean;
  fail_count?: number;
  threshold?: number;
}

export function getClientId(): string {
  if (typeof window === "undefined") {
    return "";
  }
  const existing = localStorage.getItem(CLIENT_ID_KEY);
  if (existing) {
    return existing;
  }
  const id = `tx-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  localStorage.setItem(CLIENT_ID_KEY, id);
  return id;
}

export function getLocalLoginFailCount(): number {
  if (typeof window === "undefined") {
    return 0;
  }
  const raw = localStorage.getItem(LOGIN_FAIL_KEY);
  const parsed = Number.parseInt(raw ?? "0", 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

export function setLocalLoginFailCount(count: number): void {
  if (typeof window === "undefined") {
    return;
  }
  if (count <= 0) {
    localStorage.removeItem(LOGIN_FAIL_KEY);
    return;
  }
  localStorage.setItem(LOGIN_FAIL_KEY, String(count));
}

export function recordLocalLoginFailure(): number {
  const next = getLocalLoginFailCount() + 1;
  setLocalLoginFailCount(next);
  return next;
}

export function clearLocalLoginFailures(): void {
  setLocalLoginFailCount(0);
}

export function shouldShowLoginCaptcha(
  serverRequired = false,
  serverFailCount?: number
): boolean {
  if (serverFailCount != null) {
    setLocalLoginFailCount(serverFailCount);
  }
  return (
    serverRequired || getLocalLoginFailCount() >= IMAGE_CAPTCHA_FAIL_THRESHOLD
  );
}

export function applyLoginFailureMeta(data: unknown): boolean {
  const meta = (data ?? {}) as CaptchaPolicyData;
  return shouldShowLoginCaptcha(
    Boolean(meta.required),
    typeof meta.fail_count === "number" ? meta.fail_count : undefined
  );
}
